const constants = {
    title: "חוזקות ואתגרים:",
    soon: "בקרוב!"
}

export default constants